export const DAY_IN_MS = 24 * 60 * 60 * 1000;

export const UPCOMING_BOOKINGS_DISPLAY_LIMIT = 5;

export const UPCOMING_BOOKINGS_PAGE_SIZE = 50;
